/**
 * Calculates the optimal width for a table column based on header text length.
 * Accounts for padding, sort icons, and comment icons in the column header.
 * Used primarily for dynamic application name columns in data tables.
 *
 * @param text - The header text to calculate width for (typically application names)
 * @returns The calculated column width in pixels (120-260px range)
 */
export const calculateTableColumnWidth = (text: string) => {
  const basePadding = 56; // accommodate padding, sort icon, and comment icon
  const averageCharWidth = 8; // px per character (approx)
  const minWidth = 120;
  const maxWidth = 260;
  const length = (text ?? '').length;
  return Math.max(
    minWidth,
    Math.min(maxWidth, length * averageCharWidth + basePadding),
  );
};
